import { useRoom } from "./useRoom";

export const useEnsureRoom = () => {
  const room = useRoom();
  if (!room) {
    throw new Error("Room not found");
  }
  return room;
};
